import { __rest } from "tslib";
import * as React from 'react';
const Explore = (_a) => {
    var { size } = _a, props = __rest(_a, ["size"]);
    return (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { fillRule: "evenodd", d: "M14.7 8.564a.6.6 0 01.736.736l-1.303 4.78a1.5 1.5 0 01-1.053 1.053L8.3 16.436a.6.6 0 01-.736-.736l1.303-4.78A1.5 1.5 0 019.92 9.867l4.78-1.303zm-4.237 2.192l2.781 2.781 1.043-3.824-3.824 1.043zm2.074 3.488l-2.781-2.781-1.043 3.824 3.824-1.043z" }),
        React.createElement("path", { fillRule: "evenodd", d: "M11.5 21a8.5 8.5 0 100-17 8.5 8.5 0 000 17zm0-1a7.5 7.5 0 100-15 7.5 7.5 0 000 15z" })));
};
Explore.displayName = 'Explore';
export default Explore;
//# sourceMappingURL=Explore.js.map